import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import IconButton from '@mui/material/IconButton';
import { FiMenu } from 'react-icons/fi';
import SideBar from '../SideBar/SideBar';
import './Layout.css';

const COLLAPSE_STORAGE_KEY = 'phm-sidebar-collapsed';

function readCollapsed() {
    try {
        return window.localStorage.getItem(COLLAPSE_STORAGE_KEY) === '1';
    } catch {
        return false;
    }
}

const Layout = () => {
    const muiTheme = useTheme();
    const isMobile = useMediaQuery(muiTheme.breakpoints.down('md'));

    const [mobileOpen, setMobileOpen] = useState(false);
    const [collapsed, setCollapsed] = useState(readCollapsed);

    useEffect(() => {
        try {
            window.localStorage.setItem(COLLAPSE_STORAGE_KEY, collapsed ? '1' : '0');
        } catch {
            /* ignore */
        }
    }, [collapsed]);

    // Close mobile drawer when switching to desktop
    useEffect(() => {
        if (!isMobile) setMobileOpen(false);
    }, [isMobile]);

    const sidebarWidth = collapsed && !isMobile ? 72 : 260;

    return (
        <div
            className="layout-container"
            data-sidebar-collapsed={collapsed ? 'true' : 'false'}
        >
            {isMobile && (
                <>
                    <header className="layout-mobile-bar" role="banner">
                        <IconButton
                            aria-label="Open navigation"
                            onClick={() => setMobileOpen(true)}
                            size="medium"
                        >
                            <FiMenu size={22} />
                        </IconButton>
                        <span className="layout-mobile-bar__title">Pediatrack</span>
                    </header>
                    <div
                        className={`layout-drawer-scrim ${mobileOpen ? 'is-open' : ''}`}
                        onClick={() => setMobileOpen(false)}
                        aria-hidden="true"
                    />
                    <aside
                        className={`layout-drawer ${mobileOpen ? 'is-open' : ''}`}
                        aria-label="Main navigation"
                    >
                        <SideBar onNavigate={() => setMobileOpen(false)} />
                    </aside>
                </>
            )}

            {!isMobile && (
                <aside
                    className="layout-sidebar"
                    style={{ width: sidebarWidth }}
                    aria-label="Main navigation"
                >
                    <SideBar
                        collapsed={collapsed}
                        onToggleCollapsed={() => setCollapsed((c) => !c)}
                    />
                </aside>
            )}

            <main className="layout-content">
                <Outlet />
            </main>
        </div>
    );
};

export default Layout;
